import ja from "assets/locales/ja"

export const getLocale = () => "ja"
export const setLocale = () => {}
export const toggleLocale = () => {}
export const getMessages = () => ja
